export default __webpack_public_path__ + "static/media/shape.5bbf3c3e.svg";